// import http, { expandURI } from '@/utils/ajax'
import { SPECFUNC_TTY_ACCT_INIT_LOADING, SPECFUNC_TTY_ACCT_INIT_SUCCESS, SPECFUNC_TTY_ACCT_INIT_FAIL, UPLOAD_TTY_PREM_COMM_INIT_LOADING, UPLOAD_TTY_PREM_COMM_INIT_SUCCESS, UPLOAD_TTY_PREM_COMM_INIT_FAIL, UPLOAD_TTY_CLM_PAYM_RES_INIT_LOADING, UPLOAD_TTY_CLM_PAYM_RES_INIT_SUCCESS, UPLOAD_TTY_CLM_PAYM_RES_INIT_FAIL, GEN_QUART_STMT_INIT_LOADING, GEN_QUART_STMT_INIT_SUCCESS, GEN_QUART_STMT_INIT_FAIL, BATCH_RELEASE_MTHLY_TTY_STMT_INIT_LOADING, BATCH_RELEASE_MTHLY_TTY_STMT_INIT_SUCCESS, BATCH_RELEASE_MTHLY_TTY_STMT_INIT_FAIL, BATCH_RELEASE_QRTLY_TTY_STMT_INIT_LOADING, BATCH_RELEASE_QRTLY_TTY_STMT_INIT_SUCCESS, BATCH_RELEASE_QRTLY_TTY_STMT_INIT_FAIL } from '@/store/types'
// import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  [SPECFUNC_TTY_ACCT_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [SPECFUNC_TTY_ACCT_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [SPECFUNC_TTY_ACCT_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [UPLOAD_TTY_PREM_COMM_INIT_LOADING](state) {
    state.uploadTreatyPremComm.init = 0
    state.uploadTreatyPremComm.initErr = []
    state.uploadTreatyPremComm.menu = {}
  },
  [UPLOAD_TTY_PREM_COMM_INIT_SUCCESS](state, data) {
    state.uploadTreatyPremComm.init = 1
    state.uploadTreatyPremComm.initErr = []
    state.uploadTreatyPremComm.menu = data.menu
  },
  [UPLOAD_TTY_PREM_COMM_INIT_FAIL](state, error) {
    state.uploadTreatyPremComm.init = 2
    state.uploadTreatyPremComm.initErr = error
    state.uploadTreatyPremComm.menu = {}
  },
  [UPLOAD_TTY_CLM_PAYM_RES_INIT_LOADING](state) {
    state.uploadTreatyClmPaymRes.init = 0
    state.uploadTreatyClmPaymRes.initErr = []
    state.uploadTreatyClmPaymRes.menu = {}
  },
  [UPLOAD_TTY_CLM_PAYM_RES_INIT_SUCCESS](state, data) {
    state.uploadTreatyClmPaymRes.init = 1
    state.uploadTreatyClmPaymRes.initErr = []
    state.uploadTreatyClmPaymRes.menu = data.menu
  },
  [UPLOAD_TTY_CLM_PAYM_RES_INIT_FAIL](state, error) {
    state.uploadTreatyClmPaymRes.init = 2
    state.uploadTreatyClmPaymRes.initErr = error
    state.uploadTreatyClmPaymRes.menu = {}
  },
  [UPLOAD_TTY_CLM_PAYM_RES_INIT_LOADING](state) {
    state.uploadTreatyClmPaymRes.init = 0
    state.uploadTreatyClmPaymRes.initErr = []
    state.uploadTreatyClmPaymRes.menu = {}
  },
  [UPLOAD_TTY_CLM_PAYM_RES_INIT_SUCCESS](state, data) {
    state.uploadTreatyClmPaymRes.init = 1
    state.uploadTreatyClmPaymRes.initErr = []
    state.uploadTreatyClmPaymRes.menu = data.menu
  },
  [UPLOAD_TTY_CLM_PAYM_RES_INIT_FAIL](state, error) {
    state.uploadTreatyClmPaymRes.init = 2
    state.uploadTreatyClmPaymRes.initErr = error
    state.uploadTreatyClmPaymRes.menu = {}
  },
  [GEN_QUART_STMT_INIT_LOADING](state) {
    state.genQuartStmt.init = 0
    state.genQuartStmt.initErr = []
    state.genQuartStmt.menu = {}
  },
  [GEN_QUART_STMT_INIT_SUCCESS](state, data) {
    state.genQuartStmt.init = 1
    state.genQuartStmt.initErr = []
    state.genQuartStmt.menu = data.menu
  },
  [GEN_QUART_STMT_INIT_FAIL](state, error) {
    state.genQuartStmt.init = 2
    state.genQuartStmt.initErr = error
    state.genQuartStmt.menu = {}
  },
  [BATCH_RELEASE_MTHLY_TTY_STMT_INIT_LOADING](state) {
    state.batchRelMthlyTtyStmt.init = 0
    state.batchRelMthlyTtyStmt.initErr = []
    state.batchRelMthlyTtyStmt.menu = {}
  },
  [BATCH_RELEASE_MTHLY_TTY_STMT_INIT_SUCCESS](state, data) {
    state.batchRelMthlyTtyStmt.init = 1
    state.batchRelMthlyTtyStmt.initErr = []
    state.batchRelMthlyTtyStmt.menu = data.menu
  },
  [BATCH_RELEASE_MTHLY_TTY_STMT_INIT_FAIL](state, error) {
    state.batchRelMthlyTtyStmt.init = 2
    state.batchRelMthlyTtyStmt.initErr = error
    state.batchRelMthlyTtyStmt.menu = {}
  },
  [BATCH_RELEASE_QRTLY_TTY_STMT_INIT_LOADING](state) {
    state.batchRelQrtlyTtyStmt.init = 0
    state.batchRelQrtlyTtyStmt.initErr = []
    state.batchRelQrtlyTtyStmt.menu = {}
  },
  [BATCH_RELEASE_QRTLY_TTY_STMT_INIT_SUCCESS](state, data) {
    state.batchRelQrtlyTtyStmt.init = 1
    state.batchRelQrtlyTtyStmt.initErr = []
    state.batchRelQrtlyTtyStmt.menu = data.menu
  },
  [BATCH_RELEASE_QRTLY_TTY_STMT_INIT_FAIL](state, error) {
    state.batchRelQrtlyTtyStmt.init = 2
    state.batchRelQrtlyTtyStmt.initErr = error
    state.batchRelQrtlyTtyStmt.menu = {}
  }
}
